export const CONTRACT = 'asdadasdASDASDASDASDASDASDASDasd';
export const TWITTER = 'ACADEMYWMB6VVZZK7BRYNQAWMKNNHKBVIHPXKOYPGMAF';
export const TG = 'ACADEMYWMB6VVZZK7BRYNQAWMKNNHKBVIHPXKOYPGMAF';
export const RAYDIUM = 'ACADEMYWMB6VVZZK7BRYNQAWMKNNHKBVIHPXKOYPGMAF';
export const DEXSCREENER = 'ACADEMYWMB6VVZZK7BRYNQAWMKNNHKBVIHPXKOYPGMAF';
export const GAME = 'https://test-app-omega-indol.vercel.app/';
